"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ArcGisDrawUI_1 = __importDefault(require("./ArcGisDrawUI"));
var lang = require("dojo/_base/lang");
var Evented = require("dojo/Evented");
var Draw = require("esri/toolbars/draw");
var GraphicsLayer = require("esri/layers/GraphicsLayer");
var Graphic = require("esri/graphic");
var Geometry = require("esri/geometry/Geometry");
var SymbolOptions = /** @class */ (function () {
    /**
     * Contains point, line, and polygon symbols.
     * @param {(esri/symbols/MarkerSymbol|SymbolOptionsOptions)} pointSymbolOrSymbolOptions
     * @param {esri/symbols/LineSymbol} [lineSymbol] - Required if first parameter was a MarkerSymbol.
     * @param {esri/symbols/FillSymbol} [polygonSymbol] - Required if the first parameter was a MarkerSymbol.
     * @param {esry/symbols/TextSymbol} [textSymbol] - Required if the first parameter was a MarkerSymbol
     */
    function SymbolOptions() {
        var symbols = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            symbols[_i] = arguments[_i];
        }
        if (arguments.length === 1) {
            this.point = arguments[0].point;
            this.line = arguments[0].line;
            this.polygon = arguments[0].polygon;
            this.text = arguments[0].text;
        }
        else if (arguments.length === 4) {
            this.point = arguments[0];
            this.line = arguments[1];
            this.polygon = arguments[2];
            this.text = arguments[3];
        }
        else {
            throw TypeError("Invalid number of arguments.");
        }
    }
    /**
     * Get's the symbol approprate for the graphic.
     * @param {(esri/Graphic|esri/geometries/Geometry)} graphicOrGeometry
     * @returns {esri/symbols/Symbol}
     */
    SymbolOptions.prototype.getSymbol = function (graphicOrGeometry) {
        var geometry, symbol;
        if (graphicOrGeometry) {
            if (graphicOrGeometry instanceof Graphic && graphicOrGeometry.geometry) {
                geometry = graphicOrGeometry.geometry;
            }
            else if (graphicOrGeometry instanceof Geometry &&
                graphicOrGeometry.type) {
                geometry = graphicOrGeometry;
            }
        }
        if (geometry) {
            symbol = /\w*point/i.test(geometry.type)
                ? this.point
                : /\w*line/i.test(geometry.type)
                    ? this.line
                    : this.polygon;
        }
        return symbol;
    };
    return SymbolOptions;
}());
exports.SymbolOptions = SymbolOptions;
/**
 * Creates a DrawUI and esri/toolbars/draw and then connects them.
 */
var DrawUIHelper = /** @class */ (function (_super) {
    __extends(DrawUIHelper, _super);
    /**
     *
     * @param {esri/Map} map
     * @param {HTMLElement} drawUIElement
     * @param {SymbolOptions} [symbols]
     * @param {Object} graphicsLayerOptions - See esri/layer/GraphicsLayer constructor for details.
     * @constructs
     */
    function DrawUIHelper(map, drawUIElement, symbols, graphicsLayerOptions) {
        var _this = _super.call(this) || this;
        _this.symbols = symbols;
        var self = _this;
        /**
         * Create a text symbol IF the text button is currently active; otherwise returns null.
         * @returns {?esri/symbols/TextSymbol}
         */
        function createTextSymbol() {
            var activeTextButton = drawUIElement.querySelector("button.text.active");
            // TODO: get text from a UI control.
            var output = null;
            if (activeTextButton) {
                output = lang.clone(symbols.text);
                var labelInput = drawUIElement.querySelector("input[name='label']");
                output.setText(labelInput ? labelInput.value : "");
            }
            return output;
        }
        /**
         * Removes the "active" class from the buttons.
         */
        function removeActiveStyling() {
            var activeButtons = drawUIElement.querySelectorAll("button.active");
            for (var i = 0, l = activeButtons.length; i < l; i += 1) {
                activeButtons[i].classList.remove("active");
            }
        }
        /**
         * @this {HTMLButtonElement}
         */
        var handleButtonClick = function () {
            var operation = this.value;
            if (operation) {
                if (operation === "CLEAR") {
                    if (window.confirm("Are you sure you want to delete all of your drawn features?")) {
                        gLayer.clear();
                    }
                }
                else {
                    map.setInfoWindowOnClick(false);
                    if (operation === "TEXT") {
                        draw.activate(Draw.POINT);
                        self.emit("draw-activate", {});
                    }
                    else {
                        draw.activate(Draw[operation]);
                        self.emit("draw-activate", {});
                    }
                    // Add a class to allow "active" operation's button to by styled.
                    removeActiveStyling();
                    this.classList.add("active");
                }
            }
        };
        // Setup default graphics layer options for undefined.
        if (!graphicsLayerOptions) {
            graphicsLayerOptions = {};
        }
        if (symbols && !(symbols instanceof SymbolOptions)) {
            symbols = new SymbolOptions(symbols);
        }
        _this.symbols = symbols || null;
        graphicsLayerOptions.id = graphicsLayerOptions.id || "drawnFeatures";
        graphicsLayerOptions.styling = _this.symbols
            ? true
            : Boolean(graphicsLayerOptions.styling);
        graphicsLayerOptions.className =
            graphicsLayerOptions.className || "drawn-features";
        graphicsLayerOptions.dataAttributes =
            graphicsLayerOptions.dataAttributes || "geometry-type";
        // Create a graphics layer to store drawn graphics.
        var gLayer = new GraphicsLayer(graphicsLayerOptions);
        _this.layer = gLayer;
        map.addLayer(gLayer);
        // Create the Draw toolbar.
        var draw = new Draw(map);
        _this.draw = draw;
        // Setup the Draw toolbar's event handler that will add graphics to the graphics layer.
        draw.on("draw-complete", function (e) {
            this.deactivate();
            self.emit("draw-complete", e);
            map.setInfoWindowOnClick(true);
            var graphic = new Graphic(e.geometry, symbols
                ? createTextSymbol() || symbols.getSymbol(e.geometry)
                : undefined, { "geometry-type": e.geometry.type });
            gLayer.add(graphic);
            // Remove styling for active buttons.
            removeActiveStyling();
        });
        // Create the Draw UI.
        var drawUI = new ArcGisDrawUI_1.default(drawUIElement);
        // Assign event handlers to buttons.
        var buttons = drawUI.root.querySelectorAll("button");
        for (var i = 0, l = buttons.length; i < l; i += 1) {
            buttons[i].addEventListener("click", handleButtonClick);
        }
        return _this;
    }
    return DrawUIHelper;
}(Evented));
exports.default = DrawUIHelper;
